<script setup>
defineProps({
    errors: {
        type: Array,
        default: () => [],
    },
});
</script>

<template>
    <div class="form-group" :class="{'has-error': errors.length}">
        <slot></slot>
        <p class="mt-1 px-3 text-red-500 text-sm" v-for="error in errors" :key="error">
            {{ error }}
        </p>
    </div>
</template>
